// namespace
export const STORE_NAMESPACE = 'toasts'

// actions

// mutations
export const SET_ALERT = 'SET_ALERT'
export const REMOVE_ALERT = 'REMOVE_ALERT'

// getters
